import React, { ButtonHTMLAttributes } from 'react';

import { StyledButton } from './styled';
import { ButtonProps } from './types';
import useButton from './useButton';

type ButtonAttributes = ButtonHTMLAttributes<HTMLButtonElement>;

const Button: (props: ButtonProps<ButtonAttributes>) => JSX.Element = ({ isDisabled, className, ...rest }) => {
  const modifiedProps = useButton<ButtonAttributes>({ isDisabled, ...rest });

  return <StyledButton className={className} disabled={isDisabled} {...modifiedProps} />;
};

export default Button;
